module.exports = __webpack_public_path__ + "img/check.a2b1cf12.svg";